// extracted by mini-css-extract-plugin
export var active = "PageNavigation-module--active--WaWrA";
export var link = "PageNavigation-module--link--BpWvF";
export var pages = "PageNavigation-module--pages--pBJRQ";
export var wrapper = "PageNavigation-module--wrapper--6Rt+O";